<template>
  <GroupBase>
    <p class="fs-6 mb-3 text-muted text-center">Create a new group and organize with others.</p>
    <form @submit.prevent="createGroup">
      <HorizontalInputField
        :label.once="'Group Name'"
        :value.sync="groupName"
        :placeholder.once="'Untitled Group'"
        :required.once="true"/>

      <HorizontalSelectField
        :label.once="'Privacy Setting'"
        :options.once="options"
        :selected.sync="privacySetting"
        :required.once="true"/>

      <div class="field is-horizontal">
        <div class="field-label"></div>
        <div class="field-body">
          <div class="field">
            <div class="control d-flex justify-content-end">
              <button class="button is-primary" :class="loading && 'is-loading'" type="submit">
                Create
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  </GroupBase>
</template>

<script>
import store from '../store'
import GroupBase from './GroupBase'
import HorizontalInputField from './HorizontalInputField'
import HorizontalSelectField from './HorizontalSelectField'

export default {
  name: 'GroupCreate',
  components: {
    GroupBase,
    HorizontalInputField,
    HorizontalSelectField,
  },
  data () {
    return {
      groupName: '',
      privacySetting: 'public',
      loading: false,
      options: [
        {
          value: 'public',
          text: 'Public',
        },
        {
          value: 'closed',
          text: 'Closed',
        },
        {
          value: 'private',
          text: 'Private',
        },
      ]
    }
  },
  methods: {
    createGroup () {
      this.loading = true
      const team = {
        name: this.groupName,
        privacy_setting: this.privacySetting
      }
      store.dispatch('addTeam', team)
      .then(team => {
        this.loading = false
        const url = `/groups/${team.id}`
        this.$router.push(url)
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// GroupCreate.vue?f74f44b6